import { render, staticRenderFns } from "./NewCategoryList.vue?vue&type=template&id=285bc1fc&scoped=true&"
import script from "./NewCategoryList.vue?vue&type=script&lang=js&"
export * from "./NewCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285bc1fc",
  null
  
)

export default component.exports